// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll('label.variant-radio').forEach(label => {
//         if (label.getAttribute("value") === "3 Month Supply") {
//             let disPrice = label.querySelector('.dis-price');
//             if (disPrice) {
//                 disPrice.style.display = "none";
//             }
//         }
//     });
// });
document.addEventListener('DOMContentLoaded', function () {
  //announcement
  let SwiperTop = new Swiper('.swiper--top', {
    spaceBetween: 30,
    centeredSlides: true,
    speed: 15000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    disableOnInteraction: true,
  });
});

// PDP bottom thumbnail
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.metafield_thumbnail_gallery').forEach(function (gallery) {
    new Swiper(gallery, {
      slidesPerView: 2,
      spaceBetween: 20,
      breakpoints: {
        575: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  });
});

//Article slider on blog page
// document.addEventListener('DOMContentLoaded', function() {
//   var article_slider_wrapper = document.querySelector(".article-slider");
//   if(article_slider_wrapper){
//        new Swiper(article_slider_wrapper, {
//           slidesPerView: 1,
//           navigation: {
//             nextEl: '.swiper-button-next',
//             prevEl: '.swiper-button-prev',
//           },
//           pagination: {
//             el: '.swiper-pagination',
//             clickable: true,
//             type:'fraction',
//           },
//        });
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const articleSliderWrapper = document.querySelector('.article-slider');
  const progressDuration = 10000; // 10 seconds

  if (articleSliderWrapper) {
    // Initialize Swiper
    const swiper = new Swiper(articleSliderWrapper, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function () {
          // For each custom pagination element, update total slides and start progress
          document.querySelectorAll('.custom-pagination').forEach((pagination) => {
            const totalSlidesEl = pagination.querySelector('.total-slides');
            const currentSlideEl = pagination.querySelector('.current-slide');
            const progressBar = pagination.querySelector('.progress-bar');

            if (totalSlidesEl) {
              totalSlidesEl.textContent = this.slides.length;
            }
            if (currentSlideEl) {
              currentSlideEl.textContent = this.realIndex + 1;
            }

            startProgressBar(this, pagination, progressBar);
          });
        },
        slideChange: function () {
          // Update custom pagination and reset progress for each pagination element
          document.querySelectorAll('.custom-pagination').forEach((pagination) => {
            const currentSlideEl = pagination.querySelector('.current-slide');
            const progressBar = pagination.querySelector('.progress-bar');

            if (currentSlideEl) {
              currentSlideEl.textContent = this.realIndex + 1;
            }

            resetProgressBar(this, pagination, progressBar);
          });
        },
      },
    });

    // Start the progress bar animation for a specific pagination element
    function startProgressBar(swiper, pagination, progressBar) {
      if (!progressBar) return;

      progressBar.style.transition = `width ${progressDuration}ms linear`;
      progressBar.style.width = '100%';

      // Automatically go to the next slide after the progress duration
      pagination.progressInterval = setTimeout(() => {
        if (swiper.realIndex === swiper.slides.length - 1) {
          swiper.slideTo(0); // Go to the first slide
        } else {
          swiper.slideNext(); // Otherwise, go to the next slide
        }
        resetProgressBar(swiper, pagination, progressBar);
      }, progressDuration);
    }

    // Reset the progress bar for a specific pagination element
    function resetProgressBar(swiper, pagination, progressBar) {
      if (!progressBar) return;

      // Clear the existing timeout for this pagination
      clearTimeout(pagination.progressInterval);

      progressBar.style.transition = 'none';
      progressBar.style.width = '0';

      // Restart the progress bar after resetting
      setTimeout(() => {
        startProgressBar(swiper, pagination, progressBar);
      }, 50);
    }
  }
});

//benefit section

document.addEventListener('DOMContentLoaded', function () {
  var popupOpenButtons = document.querySelectorAll('.popup-open');

  popupOpenButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var popupId = button.getAttribute('id');
      var popup = document.querySelector('.benefit-popup#' + popupId);

      if (popup) {
        // Store original parent and position for restoration
        popup.originalParent = popup.parentNode;
        popup.originalNextSibling = popup.nextSibling;
        
        // Move popup to body (portal behavior)
        document.body.appendChild(popup);
        
        popup.classList.add('active');
        // Add class to HTML element when modal opens
        document.documentElement.classList.add('modal-open');
      }
    });
  });

  // Helper function to close modal and restore DOM position
  function closeModal(popup) {
    if (popup && popup.classList.contains('active')) {
      popup.classList.remove('active');
      // Remove class from HTML element when modal closes
      document.documentElement.classList.remove('modal-open');
      
      // Remove from body and restore to original DOM position
      if (popup.originalParent) {
        // Remove from body first
        if (popup.parentNode === document.body) {
          document.body.removeChild(popup);
        }
        
        // Restore to original position
        if (popup.originalNextSibling) {
          popup.originalParent.insertBefore(popup, popup.originalNextSibling);
        } else {
          popup.originalParent.appendChild(popup);
        }
        
        // Clean up the stored references
        delete popup.originalParent;
        delete popup.originalNextSibling;
      }
    }
  }

  // Add close button functionality (using event delegation)
  document.addEventListener('click', function(event) {
    if (event.target.closest('.popup-close')) {
      var closeButton = event.target.closest('.popup-close');
      var popupId = closeButton.getAttribute('id');
      var popup = document.querySelector('.benefit-popup#' + popupId);
      closeModal(popup);
    }
  });

  // Add click outside functionality to close modals (using event delegation)
  document.addEventListener('click', function(event) {
    var popup = event.target.closest('.benefit-popup');
    if (popup && event.target === popup && popup.classList.contains('active')) {
      closeModal(popup);
    }
  });

  // Add escape key functionality to close modals
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      // Find any active modals and close them
      var activePopups = document.querySelectorAll('.benefit-popup.active');
      if (activePopups.length > 0) {
        activePopups.forEach(function(popup) {
          closeModal(popup);
        });
      }
    }
  });
});
//benefit slider
var swiper = new Swiper('.benefit_slider', {
  slidesPerView: 1.1,
  spaceBetween: 10,
});

//tab section
(function () {
  const tabButtonss = document.querySelectorAll('.tab-btn');

  // Calculate and set the tallest content height
  function setTallestContentHeight() {
    const tabVerticalSections = document.querySelectorAll('.tab-vertical-section');

    tabVerticalSections.forEach((section) => {
      const tabMainWrapper = section.querySelector('.tab-main-wrapper');
      const tabContentsContainer = section.querySelector('.tab-contents');
      const tabContents = section.querySelectorAll('.tab-contents .content');

      if (!tabMainWrapper || !tabContents.length || !tabContentsContainer) return;

      // Get the computed margin-top of .tab-contents
      const tabContentsStyles = window.getComputedStyle(tabContentsContainer);
      const tabContentsMarginTop = parseInt(tabContentsStyles.marginTop) || 0;
      const tabContentsPaddingTop = parseInt(tabContentsStyles.paddingTop) || 0;
      const tabContentsPaddingBottom = parseInt(tabContentsStyles.paddingBottom) || 0;

      let maxHeight = 0;
      
      // Temporarily show all content to measure their heights
      tabContents.forEach(content => {
        const wasActive = content.classList.contains('active');
        

        // Temporarily make visible for measurement
        if (!wasActive) {
          content.style.display = 'block';
          content.style.position = 'absolute';
          content.style.left = '-9999px';
          content.style.top = '0';
          content.style.visibility = 'visible';
        }

        
        // Get the content wrapper inside each content
        const contentWrapper = content.querySelector('.content-wrapper');
        let height = 0;
        
        if (contentWrapper) {
          // Measure the content wrapper height which is more accurate
          height = contentWrapper.offsetHeight;
        } else {
          // Fallback to content height
          height = content.scrollHeight;
        }
        
        if (height > maxHeight) {
          maxHeight = height;
        }
        
        // Restore original state
        if (!wasActive) {
          content.style.display = '';
          content.style.position = '';
          content.style.left = '';
          content.style.top = '';
          content.style.visibility = '';
        }
      });

      // Apply the tallest height to the tab-main-wrapper including tab-contents spacing
      if (maxHeight > 0) {
        // Include tab-contents margin and padding in the total height
        const totalHeight = maxHeight + tabContentsMarginTop + tabContentsPaddingTop + tabContentsPaddingBottom + 20;
        tabMainWrapper.style.height = totalHeight + 'px';
      }
    });
  }

  tabButtonss.forEach((tab) => {
    tab.addEventListener('click', () => tabClicked(tab));
  });

  function tabClicked(tab) {
    tabButtonss.forEach((tab) => tab.classList.remove('active'));
    tab.classList.add('active');

    const contents = document.querySelectorAll('.content');
    contents.forEach((content) => content.classList.remove('active'));

    const contentId = tab.getAttribute('content-id');
    const contentSelected = document.getElementById(contentId);
    if (contentSelected) {
      contentSelected.classList.add('active');
    }
  }

  // Set initial height when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setTallestContentHeight);
  } else {
    setTallestContentHeight();
  }

  // Recalculate on window resize
  window.addEventListener('resize', setTallestContentHeight);
})();

// Logo List

window.addEventListener('DOMContentLoaded', (event) => {
  if (window.matchMedia('(max-width: 749px)').matches) {
    const data = document.querySelector('.logo-list-wrapper');
    const slide_perview = Number(data.getAttribute('data-perview')) || 4;
    const space_between = Number(data.getAttribute('data-space-between')) || 20;
    const autoplay = data.getAttribute('data-autoplay') === 'true';
    const autoplay_speed = Number(data.getAttribute('data-autoplay-speed')) || 5000;

    const swiperLogoLists = document.querySelectorAll('.swiper-logo-list');

    swiperLogoLists.forEach((swiperLogoList) => {
      new Swiper(swiperLogoList, {
        slidesPerView: slide_perview,
        loop: true,
        spaceBetween: space_between,
        centeredSlides: true,
        autoplay: autoplay
          ? {
              delay: autoplay_speed,
              disableOnInteraction: false,
            }
          : false,
      });
    });
  }
});

//product media
window.addEventListener('DOMContentLoaded', (event) => {
  if (window.matchMedia('(max-width: 990px)').matches) {
    var swiper = new Swiper('.product__media-slider', {
      slidesPerView: 1.1,
      spaceBetween: 10,
    });
  }
});

//Navigation

document.addEventListener('DOMContentLoaded', function () {
  var hasChildLinks = document.querySelectorAll('.has_child-link');

  hasChildLinks.forEach(function (link) {
    link.addEventListener('mouseover', function () {
      var header = document.querySelector('.header');

      header.classList.add('active');
    });

    link.addEventListener('mouseout', function () {
      var header = document.querySelector('.header');

      header.classList.remove('active');
    });
  });
});

//testimonial
var swiper = new Swiper('.testimonial-slider', {
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  slidesPerView: 1.1,
  spaceBetween: 10,
  breakpoints: {
    768: {
      slidesPerView: 2.1,
      spaceBetween: 20,
    },
    991: {
      slidesPerView: 2.1,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3.1,
      spaceBetween: 30,
    },
    1200: {
      slidesPerView: 4.1,
      spaceBetween: 30,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


function ALAcheckCatorgy() {
  isALARenderedCategory = setInterval(function () {
    (document.querySelectorAll('[name="selling_plan"]') || null).length > 0 &&
      (clearInterval(isALARenderedCategory), initializeVariantSelectors());
  }, 500);
}
ALAcheckCatorgy();

function initializeVariantSelectors() {
  $(document).on('change', '[name="selling_plan"]', function (event) {
    console.log(`Input value: ${event.target.value}`);

    const value = event.target.value;

    // Select the element and get the attribute
    const customLiquidElement = document.querySelector('.custom-liquid');
    const closestCustomLiquidAttr = customLiquidElement.getAttribute('data-selling-plan');

    // Compare and show/hide the element based on the condition
    // if (event.target.closest('label').innerText == " ONE TIME PURCHASE") {
    //   customLiquidElement.style.display = 'block';
    // } else {
    //   customLiquidElement.style.display = 'none';
    // }
  });
}

var currentURLL = window.location.href;
// Select all the <a> elements inside the blogs-wrap
var blogLinks = document.querySelectorAll('.blogs-wrap .blog_tag a');
blogLinks.forEach((link) => {
  // Check if the current URL includes the href of the <a> tag
  if (currentURLL.includes(link.getAttribute('href'))) {
    // Add the 'active' class to the <a> tag
    link.classList.add('active');
  }
});

var isEventListenerAdded = false; // Flag to track if the event listener is added

function toggleSectionMiddleWrapsOnClick() {
  const sectionMiddleWraps = document.querySelectorAll('.section-middle-wrap .container'); // The clickable elements
  const blogsWraps = document.querySelectorAll('.blogs-wrap'); // The elements to toggle
  const accoHeads = document.querySelectorAll('.acco_head'); // The elements to add the active class to

  // If the elements don't exist, return early
  if (!sectionMiddleWraps.length || !blogsWraps.length || !accoHeads.length) return;

  // If the window width is below 960px and the event listener is not already added
  if (window.innerWidth < 768 && !isEventListenerAdded) {
    sectionMiddleWraps.forEach((sectionMiddleWrap) => {
      sectionMiddleWrap.addEventListener('click', toggleActiveClass); // Add event listener
    });
    isEventListenerAdded = true; // Mark the event listener as added
  }

  // If the window width is above 960px and the event listener is added, remove it
  if (window.innerWidth >= 768 && isEventListenerAdded) {
    sectionMiddleWraps.forEach((sectionMiddleWrap) => {
      sectionMiddleWrap.removeEventListener('click', toggleActiveClass); // Remove event listener
    });
    isEventListenerAdded = false; // Mark the event listener as removed
    blogsWraps.forEach((blogsWrap) => {
      blogsWrap.classList.remove('active'); // Remove active class
      blogsWrap.style.removeProperty('height'); // Remove inline height style
    });
    accoHeads.forEach((accoHead) => {
      accoHead.classList.remove('active'); // Remove active class from accoHeads
    });
  }
}

function toggleActiveClass() {
  const blogsWraps = document.querySelectorAll('.blogs-wrap'); // The elements to toggle
  const accoHeads = document.querySelectorAll('.acco_head'); // The elements to toggle

  blogsWraps.forEach((blogsWrap) => {
    // Toggle the active class on blogsWrap and adjust the height
    if (blogsWrap.classList.contains('active')) {
      blogsWrap.style.height = '0'; // Reset the height
      blogsWrap.classList.remove('active');
    } else {
      blogsWrap.classList.add('active');
      blogsWrap.style.height = `${blogsWrap.scrollHeight}px`; // Set the height based on content
    }
  });

  accoHeads.forEach((accoHead) => {
    // Toggle the active class on accoHead
    accoHead.classList.toggle('active');
  });
}

// Initialize the function when the page is loaded
document.addEventListener('DOMContentLoaded', function () {
  toggleSectionMiddleWrapsOnClick(); // Call it initially to apply the logic
});

// Call the function whenever the window is resized
window.addEventListener('resize', function () {
  toggleSectionMiddleWrapsOnClick(); // Reapply logic on resize
});

document.addEventListener('DOMContentLoaded', function () {
  const aboutSection = document.querySelector('.about-product-description');

  if (aboutSection) {
    const toggleIcon = aboutSection.querySelector('.collapsible-content__icon');

    if (toggleIcon) {
      requestAnimationFrame(() => {
        toggleIcon.click(); // Page load thay pachhi click karshe
      });
    }
  }
});

$('.togglefaq').click(function (e) {
  e.preventDefault();
  var notthis = $('.active').not(this);
  notthis.find('.icon-minus').addClass('icon-plus').removeClass('icon-minus');
  notthis.toggleClass('active').next('.faqanswer').slideToggle(300);
  $(this).toggleClass('active').next().slideToggle('fast');
  $(this).children('i').toggleClass('icon-plus icon-minus');
});

document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.custom-feature-collection-grid', {
    slidesPerView: 1,
    spaceBetween: 20, // Space between slides
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    breakpoints: {
      640: { slidesPerView: 2 }, // On small screens
      990: { slidesPerView: 3 }, // On medium screens
      1200: { slidesPerView: 4 }, // On large screens
    },
  });

  // Add manual BouncePop animation on swiper slide click
  document.querySelectorAll('.custom-feature-collection-grid .swiper-slide').forEach(function (slide) {
    slide.addEventListener('click', function (e) {
      const bounceElement = this.querySelector('.bouncePop');
      if (bounceElement) {
        bounceElement.style.animation = 'bouncePop .15s cubic-bezier(.01,.56,1,1) forwards';
        setTimeout(() => {
          bounceElement.style.animation = '';
        }, 150);
      }
    });

    // Add manual BouncePop animation on swiper slide click
    document.querySelectorAll('.custom-feature-collection-grid .swiper-slide').forEach(function(slide) {
      slide.addEventListener('click', function(e) {
        const bounceElement = this.querySelector('.bouncePop');
        if (bounceElement) {
          bounceElement.style.animation = 'bouncePop .15s cubic-bezier(.01,.56,1,1) forwards';
          setTimeout(() => {
            bounceElement.style.animation = '';
          }, 150);
        }
      });
    });
  });
});

var swiper = new Swiper('.sleep-steps-wrap', {
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  slidesPerView: 1.2,
  spaceBetween: 20,
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    990: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

// help-section
var swiper = new Swiper('.help-cards-wrap', {
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  slidesPerView: 1.2,
  spaceBetween: 20,
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    990: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
